
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { 
  Select, 
  SelectContent, 
  SelectItem, 
  SelectTrigger, 
  SelectValue 
} from "@/components/ui/select";

interface FitnessStepProps {
  formData: {
    fitnessLevel: string;
    activityFrequency: string;
    preferredExercises: string[];
    fitnessGoals: string;
  };
  handleInputChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  handleSelectChange: (name: string, value: string) => void;
  handleCheckboxChange: (list: string, value: string) => void;
}

export function FitnessStep({ 
  formData, 
  handleInputChange, 
  handleSelectChange, 
  handleCheckboxChange 
}: FitnessStepProps) {
  return (
    <div className="space-y-4">
      <div>
        <Label htmlFor="fitnessLevel">Fitness Level</Label>
        <Select 
          onValueChange={(value) => handleSelectChange("fitnessLevel", value)}
          value={formData.fitnessLevel}
        >
          <SelectTrigger>
            <SelectValue placeholder="Select your fitness level" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="beginner">Beginner</SelectItem>
            <SelectItem value="intermediate">Intermediate</SelectItem>
            <SelectItem value="advanced">Advanced</SelectItem>
            <SelectItem value="athletic">Athletic</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div>
        <Label htmlFor="activityFrequency">Weekly Exercise Frequency</Label>
        <Select 
          onValueChange={(value) => handleSelectChange("activityFrequency", value)}
          value={formData.activityFrequency}
        >
          <SelectTrigger>
            <SelectValue placeholder="Select exercise frequency" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="low">None</SelectItem>
            <SelectItem value="moderate">1-2 times per week</SelectItem>
            <SelectItem value="high">3-4 times per week</SelectItem>
            <SelectItem value="very-high">5+ times per week</SelectItem>
          </SelectContent>
        </Select>
        <p className="text-xs text-muted-foreground mt-1">
          This directly affects your activity level in our recommendations.
        </p>
      </div>

      <div>
        <Label>Preferred Exercise Types</Label>
        <div className="space-y-2 mt-2">
          {["cardio", "strength", "flexibility", "sports", "hiit", "yoga", "pilates", "walking"].map((exercise) => (
            <div key={exercise} className="flex items-center space-x-2">
              <Checkbox
                id={exercise}
                checked={(formData.preferredExercises as string[]).includes(exercise)}
                onCheckedChange={() => handleCheckboxChange("preferredExercises", exercise)}
              />
              <Label htmlFor={exercise}>{exercise.charAt(0).toUpperCase() + exercise.slice(1)}</Label>
            </div>
          ))}
        </div>
      </div>

      <div>
        <Label htmlFor="fitnessGoals">Fitness Goals</Label>
        <Textarea
          id="fitnessGoals"
          name="fitnessGoals"
          value={formData.fitnessGoals}
          onChange={handleInputChange}
          placeholder="What are your fitness goals?"
          className="resize-none"
        />
      </div>
    </div>
  );
}
